
import React from 'react';
import { FlowRender } from "../flow-render";
import { RadioButton, RADIO_SET_FIRST_VALUE } from "../prm/radio-button";
import { Name } from "../prm/name";
import { Popup } from "../onboarding-shared/popup";
import {ProxyDocumentDelivery} from "../docusign-constants";
import {is_ugma} from "../onboarding-utils";
import {set_access_funds_ugma} from "./risk_0";

const title = "A few legal questions we are required to ask";

const text_0 = "My investment manager can place trades for me, remit checks to me, "
  + "journal cash and securities into my custodial account, hold all my dividends "
  + "and interest in the account and sweep cash into a money market fund.";

const text_1 = "I appoint my investment manager to fulfill my responsibilities, "
  + "and do not disclose my personal info to any issuers of securities.";

const text_2 = "Use less paper by sending statements, confirms, shareholder "
  + "materials, agreements, disclosures and any regulatory documents via email.";

const invest_mgr_agree = new RadioButton(
  new Name("invest_mgr_agree"),
  [
    new Name("agree", "Agree"),
  ], [], RADIO_SET_FIRST_VALUE);
invest_mgr_agree.do_checkbox = true;

const personal_agree = new RadioButton(
  new Name("personal_agree"),
  [
    new Name("agree", "Agree"),
  ], [], RADIO_SET_FIRST_VALUE);
personal_agree.do_checkbox = true;

const green_agree = new RadioButton(
  new Name("green_agree"),
  [
    new Name("agree", "Agree"),
  ], [], RADIO_SET_FIRST_VALUE);
green_agree.do_checkbox = true;



const renderPopup = cb => {
  const text = "If you have any questions, please contact us.";
  const div_style = {
    textAlign: "center",
  };

  return (
    <Popup translate_y={"-7rem"}>
      <div style={div_style}>
        <div style={div_style}>{text}</div>
        <button
          onClick={cb}>
          Ok
        </button>
      </div>
    </Popup>
  );

}
class Authorization_0 extends FlowRender {

  constructor(index) {
    super(index, [
      invest_mgr_agree,
      personal_agree,
      green_agree,
    ]);
    invest_mgr_agree.onChangeCallback = this.onChange;
    personal_agree.onChangeCallback = this.onChange;
    green_agree.onChangeCallback = this.onChange;
    this.url = "authorization_0";
  }

  init(componentState, appState) {
    super.init(componentState, appState);
    [ invest_mgr_agree, personal_agree, green_agree].forEach(prm => {
      const id = 'show_popup_' + prm.name.id;
      componentState[id] = false;
    })
  }

  onChange = (component, newState) => {
    [ invest_mgr_agree, personal_agree, green_agree].forEach(prm => {
      if (!prm.isClicked(newState) && prm.isClicked(component.state)) {
        const popup_id = 'show_popup_' + prm.name.id;
        newState[popup_id] = true;
      }
    })
  };

  canNavigateNext(component) {
    const highlight_rects = [];

    [ invest_mgr_agree, personal_agree, green_agree].forEach(prm => {
      prm.isFilledElseHighlight(component.state, highlight_rects);
    })

    if (highlight_rects.length > 0) {
      component.setState({ highlight_rects });
      return null;
    }

    const no_envelope =
      component.getOnboardingData().docusign_delivery_type === ProxyDocumentDelivery.NO_ENVELOPE;

    if (component.isBaseAcct() && !no_envelope) {
      return component.getRootUrl() + "/finra_affiliation";
    }
    if (is_ugma(component.getOnboardingData())) {
      // Access in 30, spend in 30
      component.writeIfDirty(set_access_funds_ugma());
      if (component.isBaseAcct()) {
        return component.getRootUrl() + "/risk_1";
      }
      // For non-base accts, we don't need to re-ask the risk questions
      return component.getRootUrl() + "/risk_2";
    }
    return component.getRootUrl() + "/risk_0";
  }

  okClicked = (component, popup_id) => ev => {
    component.setState({
      [popup_id]: false,
    })
  };

  dumpTextCheckbox = (component, prm, text) => {
    // const popup_id = 'show_popup_' + prm.name.id;
    // const popup = component.state[popup_id]
    //   ? renderPopup(this.okClicked(component, popup_id))
    //   : null;

    return (
      <div>
        <div style={{height: "2rem"}}/>
        <div>{text}</div>
        <div style={{height: "1rem"}}/>
        <div style={{ display: "flex", alignItems: "center", paddingBottom: "1rem" }}>
          {/* { prm.renderCheckboxDiv(0, component) } */}
          {/* { prm.renderLabel(0, component.state, {marginLeft: "1rem"}) } */}
          { prm.renderRadioLabel(0, component) }
        </div>
     
      </div>
    )
  }

  renderBody = component => {
    return (
      <div>
        <div style={{fontSize: "1.5rem"}}>{title}</div>
        <div style={{height: "1rem"}}/>
        { this.dumpTextCheckbox(component, invest_mgr_agree, text_0) }
        { this.dumpTextCheckbox(component, personal_agree, text_1) }
        { this.dumpTextCheckbox(component, green_agree, text_2) }
      </div>
    )
  };

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Agreements", "50%", "952126710")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(this.renderBody(component), "50%")}
        { this.renderNextButtonRow(component, true)}
      </div>
    )
  }

};

export { Authorization_0, renderPopup, text_0 };
